import React, { useState } from "react";
import { downloadAdmitCard } from "../../utils/downloadAdmitCard";
import { downloadApplication } from "../../utils/downloadApplication";

const ApplicationCard = ({ item, isPendingPayment, onShowDetails }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [localLoading, setLocalLoading] = useState(false);
  const [isDownloadingApplication, setIsDownloadingApplication] = useState(false);

  const handleDownloadApplication = async () => {
    setIsDownloadingApplication(true);
    const token = localStorage.getItem("adminToken");

    try {
      const detailsUrl = item.admission?.detailsUrl || item.detailsUrl;
      if (detailsUrl) {
        await downloadApplication(detailsUrl, token);
      } else {
        console.error("No valid details URL found");
        alert("Cannot download application: missing details URL.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to download application. Please try again.");
    } finally {
      setIsDownloadingApplication(false);
    }
  };

  const handleDownloadAdmitCard = async () => {
    setIsDownloading(true);
    const token = localStorage.getItem("adminToken");

    try {
      const detailsUrl = item.admission?.detailsUrl || item.detailsUrl;
      if (detailsUrl) {
        await downloadAdmitCard(detailsUrl, token);
      } else {
        alert("Cannot download admit card: missing details URL.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to download admit card. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="p-6 border rounded-lg shadow-md bg-white relative">
      {(item.updated_at || item.admission?.updated_at) && (
        <div className="absolute top-4 right-4 bg-blue-50 text-blue-700 px-3 py-1 rounded-md border border-blue-100 flex flex-col items-center shadow-sm">
          <span className="text-xs font-bold whitespace-nowrap">
            {new Date(item.updated_at || item.admission?.updated_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
          </span>
          <span className="text-[10px] text-blue-500 font-medium tracking-wide">
            {new Date(item.updated_at || item.admission?.updated_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
      )}

      {/* Title for Normal Data */}
      {!isPendingPayment && (
        <h3 className="text-xl font-semibold text-blue-700 pr-24">
          {item.first_name && item.last_name
            ? `${item.first_name} ${item.last_name}`
            : "No Name"}
        </h3>
      )}

      {/* Title for Pending Payments */}
      {isPendingPayment && (
        <h3 className="text-xl font-semibold text-red-600 pr-24">
          Pending Payment: {item.type}
        </h3>
      )}

      {/* Common Fields */}
      <p className="text-gray-600 mt-2">
        {isPendingPayment ? "Amount: " + item.amount : ""}
      </p>
      <p className="text-gray-600">
        Status:{" "}
        <span
          className={`font-semibold ${item.status === "Approved"
            ? "text-green-500"
            : item.status === "Pending"
              ? "text-yellow-500"
              : "text-red-500"
            }`}
        >
          {item.status}
        </span>
      </p>

      {/* Timestamp Fields */}
      {(item.created_at || item.admission?.created_at) && (
        <p className="text-gray-400 text-xs mt-1 mb-2 font-medium">
          Created At: {new Date(item.created_at || item.admission?.created_at).toLocaleString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
          })}
        </p>
      )}

      {/* Additional Fields for Pending Payments */}
      {isPendingPayment && item.admission && (
        <>
          <p className="text-gray-500">
            Student Name:{" "}
            {item.admission.first_name && item.admission.last_name
              ? `${item.admission.first_name} ${item.admission.last_name}`
              : "No Name"}
          </p>
          <p className="text-gray-500">
            Class: {item.admission.class ? item.admission.class.name : "Not Assigned"}
          </p>
        </>
      )}

      {!isPendingPayment && (
        <>
          {item.application_no && (
            <p className="text-gray-500">Application No: {item.application_no}</p>
          )}

          <p className="text-gray-500">
            Student Name:{" "}
            {item.first_name && item.last_name
              ? `${item.first_name} ${item.last_name}`
              : "No Name"}
          </p>

          {item.class?.name && <p className="text-gray-500">Class: {item.class.name}</p>}
        </>
      )}

      {/* Buttons */}
      <div className="mt-4 space-y-2">
        {!isPendingPayment && item.status === "Approved" && (item.detailsUrl || item.admission?.detailsUrl) && (
          <button
            onClick={handleDownloadAdmitCard}
            disabled={isDownloading}
            className="block w-full px-4 py-2 text-center text-white bg-green-600 rounded-lg hover:bg-green-700 transition"
          >
            {isDownloading ? "Downloading..." : "Download Admit Card"}
          </button>
        )}

        {/* More Details Button */
          // console.log(item.detailsUrl,"duuuuu")
        }
        <button
          onClick={async () => {
            const detailsUrl = item.admission?.detailsUrl || item.detailsUrl;
            if (detailsUrl) {
              setLocalLoading(true); // start loading
              try {
                await onShowDetails(detailsUrl); // wait for fetch to complete
              } catch (err) {
                console.error("Error loading details:", err);
              }
              setLocalLoading(false); // end loading
            } else {
              console.error("No valid details URL found");
            }
          }}
          disabled={localLoading}
          className="block w-full px-4 py-2 text-center text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition"
        >
          {localLoading ? "Loading..." : "More Details"}
        </button>
        <button
          onClick={handleDownloadApplication}
          disabled={isDownloadingApplication}
          className="block w-full px-4 py-2 text-center text-white bg-green-600 rounded-lg hover:bg-green-700 transition"
        >
          {isDownloadingApplication ? "Downloading..." : "Download Application"}
        </button>
      </div>
    </div>
  );
};

export default ApplicationCard;
